
import { InitOptionsType } from './index';
import { MapController } from './map/map';
import { StateController } from './controller/controller';
import { BasemapController } from './map/map.basemap';

export let globalMapObject: MapController;
export let stateControllerPromise: Promise<StateController>;    // use when need to ensure existance
export let globalOnSubmitCallback: ((data: { id: string, area: number, products: string[] }) => void) = function (data: { id: string, area: number, products: string[] }) { console.log(data.id); console.log("dummy submit function executed. None actual provided through init options"); };
export let globalDebugFlag: boolean;


let stateController: StateController;
let node_application_container: HTMLDivElement;
export let stored_init_options: InitOptionsType;

export class ClientApiModule {
    constructor() {

    }

    async init(options: InitOptionsType) {

        stored_init_options = options;
        globalDebugFlag = options.debug || false;

        if (options.onsubmit) {
            globalOnSubmitCallback = options.onsubmit;
        }

        this._init();
        // {
        //     node_application_container = <HTMLDivElement>document.getElementById(options.target);
        //     await wait(100);
        //     globalMapObject = new MapController(node_application_container);

        //     let resolveStateControllerPromiseCreated = (value?: StateController) => { };
        //     stateControllerPromise = new Promise<StateController>((resolve, reject) => { resolveStateControllerPromiseCreated = resolve });
        //     stateController = new StateController(node_application_container);
        //     resolveStateControllerPromiseCreated(stateController);
        // }
    }


    private async _init() {
        node_application_container = <HTMLDivElement>document.getElementById(stored_init_options.target);
        await wait(100);
        let b = new BasemapController(node_application_container);
        globalMapObject = new MapController(node_application_container, b.layers);

        let resolveStateControllerPromiseCreated = (value?: StateController) => { };
        stateControllerPromise = new Promise<StateController>((resolve, reject) => { resolveStateControllerPromiseCreated = resolve });
        stateController = new StateController(node_application_container);
        resolveStateControllerPromiseCreated(stateController);
    }

    reset() {
        console.log('api reset');
        stateController.dispose();
        globalMapObject.dispose();
        this._init();
    }

    refresh() {
        console.log('regen ui function');
    }
}




async function wait(ms: number) {
    return new Promise((r, rj) => {
        setTimeout(() => { r() }, ms);
    });
}
